import { ChevronRightIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import Image from "next/legacy/image";
import Link from "next/link";

interface Props {
  items: {
    key: string;
    label: string;
    href: string;
    imageSrc: string;
    isActive: boolean;
  }[];
}

const SidebarListNavigation = ({ items }: Props) => {
  return (
    (<ul className={clsx("flex flex-col space-y-1")}>
      {items.map((item) => {
        return (
          (<li key={item.key} className={clsx("flex w-full")}>
            <Link
              href={item.href}
              className={clsx(
                "group flex grow flex-row items-center rounded-full p-1.5 transition ease-out hover:bg-white",
                {
                  "bg-white": item.isActive,
                }
              )}>

              <div className={clsx("flex items-center space-x-4")}>
                <div
                  className={clsx(
                    "relative aspect-square h-14 w-14 overflow-hidden rounded-full bg-zinc-100 xl:h-16 xl:w-16"
                  )}
                >
                  {!!item.imageSrc && (
                    <Image
                      src={item.imageSrc}
                      alt={item.label}
                      objectFit="cover"
                      layout="fill"
                    />
                  )}
                </div>
                <div
                  className={clsx(
                    "font-body text-sm transition ease-out group-hover:text-zinc-900"
                  )}
                >
                  {item.label}
                </div>
              </div>
              <div
                className={clsx(
                  "ml-auto flex h-12 w-12 -translate-x-1 items-center justify-center opacity-0 transition ease-out group-hover:translate-x-0 group-hover:opacity-100",
                  {
                    "translate-x-0 opacity-100": item.isActive,
                  }
                )}
              >
                <ChevronRightIcon className="h-4 w-4 text-zinc-500" />
              </div>

            </Link>
          </li>)
        );
      })}
    </ul>)
  );
};

export default SidebarListNavigation;
